import { NgModule } from '@angular/core';
import { NbCardModule } from '@nebular/theme';
import { NgChartsModule } from 'ng2-charts';
@NgModule({
  imports: [NgChartsModule, NbCardModule],
  exports: [NgChartsModule, NbCardModule],
  declarations: []
})
export class ChartsModule {}
